import * as Accordion from '@radix-ui/react-accordion';
import { PlusIcon, MinusIcon } from '@radix-ui/react-icons';
import { Helmet } from 'react-helmet-async';
import { PageSEO } from '@trashlab/sitesapp/src/templates/redebins/components/shared/page-seo';

export const FaqContent = () => {
  const faqs = [
    {
      question: "FAQ: How big is a RED-E-BIN Dumpster?",
      answer: "RED-E-BINS come in two compact sizes: 5YD (8x4x4) and 10YD (10x5x5). Both are designed to fit in driveways and tight spaces, making them perfect for residential and commercial projects.",
    },
    {
      question: "FAQ: How long can I keep my RED-E-BIN Dumpster?",
      answer: "Our standard rental period is flexible to accommodate your project timeline. Contact us at 952-931-2577 to discuss extended rental options if needed.",
    },
    {
      question: "FAQ: What can't I put in a RED-E-BIN Dumpster?",
      answer: "Prohibited items include hazardous waste, electronics, appliances, batteries, paint, oils, and yard waste. For a complete list, see our Do's and Don'ts page.",
    },
    {
      question: "FAQ: Do you take electronics, appliances, or large bulk items like couches?",
      answer: "Electronics and appliances are not accepted in our dumpsters. However, we offer junk removal services that can handle these items. Contact us at 952-931-2577 for more information.",
    },
    {
      question: "FAQ: Is there a weight limit?",
      answer: "Yes, our dumpsters have a weight limit of 3 tons (6,000 lbs). Additional fees may apply if this limit is exceeded.",
    },
    {
      question: "FAQ: Are there any extra fees associated with the dumpster bin rental?",
      answer: "Our pricing is straightforward and competitive. Additional fees may apply for mattresses, box springs, or if weight limits are exceeded. Contact us for detailed pricing information.",
    },
    {
      question: "FAQ: Can I put my container on the street?",
      answer: "RED-E-BIN dumpsters are designed to fit in driveways and on private property. Street placement may require permits depending on your location. Contact us to discuss your specific situation.",
    },
    {
      question: "FAQ: Can I rent more than one RED-E-BIN Dumpster at a time?",
      answer: "Absolutely! We can accommodate projects requiring multiple dumpsters. Contact us at 952-931-2577 to discuss your needs and availability.",
    },
  ];

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <>
      <PageSEO pathname="/faq" />
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(faqSchema)}
        </script>
      </Helmet>
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            <div className="grid md:grid-cols-2 gap-12 mb-12">
            {/* Left Column - Image */}
            <div>
              <img
                src="https://mn.redebins.com/wp-content/uploads/sites/148/2019/05/Redebins-Vinny-Ask-Me-Anything.jpg"
                alt="FAQ"
                className="w-full h-auto rounded-lg"
                onError={(e) => {
                  // Fallback to local image if remote fails
                  (e.target as HTMLImageElement).src = '/redebins/images/binny-mascot.png';
                }}
              />
            </div>

            {/* Right Column - Content */}
            <div>
              <h2 className="text-3xl md:text-4xl font-bold text-[#333333] mb-4">
                Commonly Asked Dumpster Rental Questions
              </h2>
              <p className="text-[#333333] mb-8">
                <strong>Everything You Need to Know About RED-E-BIN Dumpster Rentals</strong> At RED-E-BINS, we make dumpster rentals simple, quick, and hassle-free. Whether you're tackling a small cleanup or a major renovation, our FAQs cover everything you need to know. Find answers to questions about dumpster sizes, rental periods, acceptable materials, weight limits, additional fees, and even street placement rules. Wondering if you can rent more than one or dispose of appliances? We've got you covered. Dive in to learn more about how RED-E-BIN is the perfect solution for your waste removal needs!
              </p>
            </div>
          </div>

          <Accordion.Root type="single" collapsible className="space-y-4">
            {faqs.map((faq, index) => (
              <Accordion.Item
                key={index}
                value={`faq-${index}`}
                className="bg-white rounded-lg border-2 border-gray-200"
              >
                <Accordion.Trigger className="group flex w-full justify-between items-center gap-5 px-6 py-4 text-left text-lg font-semibold text-[#333333] hover:text-[#E31837] transition-colors">
                  <span>{faq.question}</span>
                  <span className="shrink-0">
                    <PlusIcon className="w-5 h-5 transition-transform duration-200 group-data-[state=open]:hidden text-[#E31837]" />
                    <MinusIcon className="w-5 h-5 transition-transform duration-200 hidden group-data-[state=open]:block text-[#E31837]" />
                  </span>
                </Accordion.Trigger>
                <Accordion.Content className="overflow-hidden data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down px-6 pb-4">
                  <p className="text-[#333333] leading-7">{faq.answer}</p>
                </Accordion.Content>
              </Accordion.Item>
            ))}
            </Accordion.Root>
          </div>
        </div>
      </section>
    </>
  );
};

